/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicaidCase } from './MedicaidCase';
import {
    MedicaidCaseFromJSON,
    MedicaidCaseFromJSONTyped,
    MedicaidCaseToJSON,
    MedicaidCaseToJSONTyped,
} from './MedicaidCase';

/**
 * 
 * @export
 * @interface LeadMedicaidCaseResponseData
 */
export interface LeadMedicaidCaseResponseData {
    /**
     * 
     */
    active_case: MedicaidCase | null;
}

/**
 * Check if a given object implements the LeadMedicaidCaseResponseData interface.
 */
export function instanceOfLeadMedicaidCaseResponseData(value: object): value is LeadMedicaidCaseResponseData {
    if (!('active_case' in value) || value['active_case'] === undefined) return false;
    return true;
}

export function LeadMedicaidCaseResponseDataFromJSON(json: any): LeadMedicaidCaseResponseData {
    return LeadMedicaidCaseResponseDataFromJSONTyped(json, false);
}

export function LeadMedicaidCaseResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadMedicaidCaseResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'active_case': MedicaidCaseFromJSON(json['active_case']),
    };
}

export function LeadMedicaidCaseResponseDataToJSON(json: any): LeadMedicaidCaseResponseData {
    return LeadMedicaidCaseResponseDataToJSONTyped(json, false);
}

export function LeadMedicaidCaseResponseDataToJSONTyped(value?: LeadMedicaidCaseResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active_case': MedicaidCaseToJSON(value['active_case']),
    };
}

